import productsData from "../data/products.json";
import axios from "axios";

// Site API key — every backend call from this website identifies itself
export const SITE_API_KEY = process.env.REACT_APP_SITE_API_KEY;
axios.defaults.headers.common["X-API-Key"] = SITE_API_KEY;

// ---- Store constants (real data from regaljewels.com) ----
export const STORE = {
  name: "Regal Jewels",
  tagline: "Elevate your style with Regal Jewels. Explore 18k, 22k & 24k gold, silver & diamond jewelry online or at our Chicago store. USA-wide delivery.",
  address: "2625 W. Devon Ave., Chicago, IL 60659",
  phone: "773-262-4377",
  whatsapp: "773-517-0574",
  whatsappLink: "https://wa.me/17735170574",
  email: "regaljewelsinc@gmail.com",
  logo: "/regal-crown.png",
  hours: [
    { d: "Open 7 Days a Week", h: "11:00 AM – 8:00 PM" },
    { d: "Walk-ins & Consultations", h: "Welcome Daily" },
  ],
};

// Real Regal Jewels brand assets (uploaded by owner)
export const BRAND = {
  kaajalModel: "https://customer-assets-cm19k8pv.emergentagent.net/job_product-import-6/artifacts/9wsog6kz_1.png",
  kaajalDuo: "https://customer-assets-cm19k8pv.emergentagent.net/job_product-import-6/artifacts/7wvd8c8o_2.png",
  jewelryShow: "https://customer-assets-cm19k8pv.emergentagent.net/job_product-import-6/artifacts/jn6v67o1_22k%20Gold%20Jewelry%20Show%20Regal%20Jewels%20%281414%20x%202000%20px%29.png",
  heroVideo: "https://customer-assets-cm19k8pv.emergentagent.net/job_product-import-6/artifacts/m9da827b_Regal%20Jewels%20Video%20South%20Style.mp4",
  goldBanner: "https://customer-assets-cm19k8pv.emergentagent.net/job_product-import-6/artifacts/bv1ccxo2_Timeless%20Elegance.%20Enduring%20Craftmanship..webp",
  couple: "https://customer-assets-cm19k8pv.emergentagent.net/job_product-import-6/artifacts/rtzhidwk_Add%20a%20little%20bit%20of%20body%20text.png",
  storefront: "https://customer-assets-cm19k8pv.emergentagent.net/job_product-import-6/artifacts/71678wqp_Punjab%20Times%20AD%20lower.png",
  collage: "https://customer-assets-cm19k8pv.emergentagent.net/job_product-import-6/artifacts/qtjyix5j_Regal%20Jewels%20Facebook%20Cover%20%28851%20%C3%97%20351%20px%29%20%28800%20%C3%97%20351%20px%29.png",
  kaajalBanner: "https://customer-assets-cm19k8pv.emergentagent.net/job_product-import-6/artifacts/zyequ1sb_Regal%20Jewels%2022k%20Gold%20%28Kaajal%20Collection%29%20Tradition%20Well%20Imagined%20Banner.png",
  offerBanner: "https://customer-assets-cm19k8pv.emergentagent.net/job_product-import-6/artifacts/zhozafho_Regal%20Jewels%20%E2%80%94%20For%20those%20who%20were%20born%20to%20shine%201000x1500%20%281920%20x%201080%20px%29.png",
  sunsetStore: "https://customer-assets-cm19k8pv.emergentagent.net/job_product-import-6/artifacts/8a3lb9t5_Regal%20Jewels%20Whatsapp%20DP%20.png",
  kaajalCover: "https://customer-assets-cm19k8pv.emergentagent.net/job_product-import-6/artifacts/coicntpm_Kaajal%20Collection%20by%20Regal%20Jewels%20Magazine%20Cover.webp",
  thankYouCard: "https://customer-assets-cm19k8pv.emergentagent.net/job_product-import-6/artifacts/y7nm9e3b_Regal%20Jewels%20Thank%20You%20Postcard.png",
  thankYou: "https://customer-assets-cm19k8pv.emergentagent.net/job_product-import-6/artifacts/45r0nfdo_Thank%20you%20Regal%20Jewels%20ad.webp",
  oneStopShop: "https://customer-assets-cm19k8pv.emergentagent.net/job_product-import-6/artifacts/740ic7i2_Regal%20Jewels%20Facebook%20Cover%20%28851%20%C3%97%20351%20px%29%20%28851%20%C3%97%20300%20px%29.png",
  tagline: "For those who were born to shine.",
};

// New product drop banners (uploaded by owner)
export const NEW_DROPS = [
  {
    img: "https://customer-assets-cm19k8pv.emergentagent.net/job_product-import-6/artifacts/dxv73un9_2.webp",
    alt: "22kt gold belts and vadanams collection — new at Regal Jewels",
    to: "/collections/gold",
    wide: true,
  },
  {
    img: "https://customer-assets-cm19k8pv.emergentagent.net/job_product-import-6/artifacts/5095reel_1.webp",
    alt: "22kt gold bangles collection — new at Regal Jewels",
    to: "/shop?type=bangles",
  },
  {
    img: "https://customer-assets-cm19k8pv.emergentagent.net/job_product-import-6/artifacts/zg7jr6x6_3.webp",
    alt: "22kt gold diamond-studded bangles collection — new at Regal Jewels",
    to: "/collections/diamond",
  },
  {
    img: "https://customer-assets-cm19k8pv.emergentagent.net/job_product-import-6/artifacts/lfns22jr_4.webp",
    alt: "22kt gold men's bracelets collection — new at Regal Jewels",
    to: "/shop?type=bracelets&audience=men",
  },
  {
    img: "https://customer-assets-cm19k8pv.emergentagent.net/job_product-import-6/artifacts/3qz66p0p_5.webp",
    alt: "22kt gold bridal accessories collection — new at Regal Jewels",
    to: "/shop?type=tikka",
  },
];

export const IMAGES = {
  hero: BRAND.goldBanner,
  consultation: BRAND.kaajalModel,
};

// House collections (sub-brands by Regal Jewels)
export const HOUSE_COLLECTIONS = [
  { name: "Kaajal Collection", desc: "22K Gold", to: "/collections/gold" },
  { name: "Mita Collection", desc: "Diamonds", to: "/collections/diamond" },
  { name: "Rahi Gi Pure", desc: "24K Gold", to: "/collections/bullion" },
  { name: "KaviGi", desc: "Kids", to: "/collections/kids" },
  { name: "Kali Gi", desc: "Baby", to: "/shop?search=baby" },
  { name: "Sari Sapne", desc: "Clothing — In Store", to: null },
];

// ---- Collection landing pages (shareable URLs) ----
export const COLLECTIONS = [
  {
    slug: "gold",
    title: "22K Gold",
    blurb: "Handcrafted 22kt gold — chains, bangles, bridal sets and heirlooms in the purest tradition.",
    banner: BRAND.goldBanner,
    bannerPos: "object-[70%_top]",
    filter: { category: "gold" },
  },
  {
    slug: "diamond",
    title: "Diamonds",
    blurb: "Certified 14K and 18K diamond rings, chains and earrings — brilliance for every occasion.",
    banner: BRAND.kaajalDuo,
    filter: { category: "diamond" },
  },
  {
    slug: "silver",
    title: "Silver",
    blurb: "Sterling silver chains, pooja items and everyday elegance.",
    banner: null,
    filter: { category: "silver" },
  },
  {
    slug: "wedding-bands",
    title: "Wedding Bands",
    blurb: "MALO bands in tantalum, tungsten, titanium and gold — made for a lifetime.",
    banner: null,
    filter: { category: "wedding-bands" },
  },
  {
    slug: "women",
    title: "For Her",
    blurb: "Earrings, sets, mangalsutras and bangles curated for her.",
    banner: BRAND.kaajalCover,
    filter: { audience: "women" },
  },
  {
    slug: "men",
    title: "For Him",
    blurb: "Bold chains, kadas, rings and bracelets for him.",
    banner: null,
    filter: { audience: "men" },
  },
  {
    slug: "kids",
    title: "For Kids",
    blurb: "Delicate bangles, chains and rings for little ones.",
    banner: null,
    filter: { audience: "kids" },
  },
  {
    slug: "lladro",
    title: "Lladró",
    blurb: "Fine Spanish porcelain figurines from an authorized dealer.",
    banner: null,
    filter: { category: "lladro" },
  },
  {
    slug: "bullion",
    title: "Bullion",
    blurb: "24K gold and silver bullion — PAMP, Valcambi and Credit Suisse.",
    banner: null,
    filter: { category: "bullion" },
  },
];

export function getCollectionBySlug(slug) {
  return COLLECTIONS.find((c) => c.slug === slug);
}

export function collectionBanner(col) {
  if (col.banner) return col.banner;
  const key = col.filter.category || null;
  const aud = col.filter.audience || null;
  const p = allProducts.find(
    (x) => (key ? x.categories.includes(key) : true) && (aud ? x.audience.includes(aud) : true) && x.images[0]
  );
  return p ? p.images[0] : IMAGES.hero;
}

// ---- Wishlist (browser-side) ----
export function getWishlist() {
  try {
    return JSON.parse(localStorage.getItem("rj_wishlist") || "[]");
  } catch (e) {
    console.warn("Wishlist read failed:", e?.message);
    return [];
  }
}

export function isWishlisted(handle) {
  return getWishlist().includes(handle);
}

export function toggleWishlist(handle) {
  const list = getWishlist();
  const next = list.includes(handle) ? list.filter((h) => h !== handle) : [handle, ...list];
  try {
    localStorage.setItem("rj_wishlist", JSON.stringify(next));
  } catch (e) {
    console.warn("Wishlist save failed:", e?.message);
  }
  window.dispatchEvent(new Event("rj-wishlist"));
  return next.includes(handle);
}

export function getWishlistProducts() {
  return getWishlist()
    .map((h) => allProducts.find((p) => p.handle === h))
    .filter(Boolean);
}

// ---- Recently viewed (browser-side) ----
export function addRecentlyViewed(handle) {
  try {
    let list = JSON.parse(localStorage.getItem("rj_recent") || "[]");
    list = [handle, ...list.filter((h) => h !== handle)].slice(0, 8);
    localStorage.setItem("rj_recent", JSON.stringify(list));
  } catch (e) {
    console.warn("Recently-viewed save failed:", e?.message);
  }
}

export function getRecentlyViewed(excludeHandle) {
  try {
    const list = JSON.parse(localStorage.getItem("rj_recent") || "[]");
    return list
      .filter((h) => h !== excludeHandle)
      .map((h) => allProducts.find((p) => p.handle === h))
      .filter(Boolean);
  } catch (e) {
    console.warn("Recently-viewed read failed:", e?.message);
    return [];
  }
}

export const CATEGORIES = [
  { key: "gold", label: "22K Gold", blurb: "Handcrafted 22kt gold jewelry" },
  { key: "diamond", label: "Diamond", blurb: "14K & 18K certified diamonds" },
  { key: "silver", label: "Silver", blurb: "Chains, pooja items & more" },
  { key: "wedding-bands", label: "Wedding Bands", blurb: "MALO tantalum, tungsten & gold" },
  { key: "lladro", label: "Lladró", blurb: "Fine porcelain figurines" },
  { key: "bullion", label: "Bullion", blurb: "24K gold & silver bullion" },
];

export const TYPES = [
  { key: "chains", label: "Chains" },
  { key: "earrings", label: "Earrings" },
  { key: "rings", label: "Rings" },
  { key: "pendants", label: "Pendants" },
  { key: "bangles", label: "Bangles" },
  { key: "bracelets", label: "Bracelets" },
  { key: "sets", label: "Sets" },
  { key: "mangalsutra", label: "Mangalsutra" },
  { key: "murti", label: "Murti" },
  { key: "payal", label: "Payal" },
  { key: "tikka", label: "Tikka" },
  { key: "nosepin", label: "Nosepin" },
];

export const AUDIENCES = [
  { key: "women", label: "Women" },
  { key: "men", label: "Men" },
  { key: "kids", label: "Kids" },
];

// ---- Products (loaded from backend; bundled JSON as fallback) ----
export let allProducts = productsData.products;
let featuredHandles = [];

export async function loadCatalog() {
  try {
    const res = await axios.get(`${API}/catalog`);
    if (res.data.products && res.data.products.length > 0) {
      allProducts = res.data.products;
    }
    featuredHandles = res.data.featured || [];
  } catch (e) {
    console.warn("Catalog API unavailable — using bundled products:", e?.message);
  }
}

export function getProduct(handle) {
  return allProducts.find((p) => p.handle === handle);
}

export function filterProducts({ category, type, audience, search, sort } = {}) {
  let list = allProducts;
  if (category) list = list.filter((p) => p.categories.includes(category));
  if (type) list = list.filter((p) => p.types.includes(type));
  if (audience) list = list.filter((p) => p.audience.includes(audience));
  if (search) {
    const q = search.toLowerCase();
    list = list.filter(
      (p) =>
        p.title.toLowerCase().includes(q) ||
        p.tags.some((t) => t.toLowerCase().includes(q))
    );
  }
  if (sort === "price-asc") list = [...list].sort((a, b) => (a.price || Infinity) - (b.price || Infinity));
  else if (sort === "price-desc") list = [...list].sort((a, b) => b.price - a.price);
  else if (sort === "newest")
    list = [...list].sort((a, b) => (b.publishedAt || "").localeCompare(a.publishedAt || ""));
  return list;
}

// Latest active products (valid image + price), newest first — updates on every Shopify sync
export function getNewArrivals(count = 8) {
  return allProducts
    .filter((p) => p.images && p.images.length > 0 && p.price > 0)
    .sort((a, b) => (b.publishedAt || "").localeCompare(a.publishedAt || ""))
    .slice(0, count);
}

const FEATURED_HINTS = [
  "d-earrings-rjde3157", "d-earrings-rjde3156", "d-earrings-rjde3142",
  "diamond-ring-rjdr3336", "18kt-diamond-ring-rjdr3129", "diamond-ring-rjdr3379",
  "l-earrings-rjle3773", "l-earrings-rjle3774",
];

export function getFeatured(count = 8) {
  // Admin-picked featured products take priority
  if (featuredHandles.length > 0) {
    const picked = featuredHandles
      .map((h) => allProducts.find((p) => p.handle === h))
      .filter(Boolean);
    if (picked.length > 0) {
      if (picked.length < count) {
        const extra = allProducts
          .filter((p) => p.compareAtPrice && !picked.includes(p))
          .slice(0, count - picked.length);
        picked.push(...extra);
      }
      return picked.slice(0, Math.max(count, picked.length));
    }
  }
  const feats = FEATURED_HINTS.map((h) =>
    allProducts.find((p) => p.handle.includes(h))
  ).filter(Boolean);
  if (feats.length < count) {
    const extra = allProducts
      .filter((p) => p.compareAtPrice && !feats.includes(p))
      .slice(0, count - feats.length);
    feats.push(...extra);
  }
  return feats.slice(0, count);
}

export function getRelated(product, count = 4) {
  return allProducts
    .filter(
      (p) =>
        p.handle !== product.handle &&
        p.types.some((t) => product.types.includes(t)) &&
        p.categories.some((c) => product.categories.includes(c))
    )
    .slice(0, count);
}

export function categoryImage(catKey) {
  const p = allProducts.find((p) => p.categories.includes(catKey) && p.images[0]);
  return p ? p.images[0] : IMAGES.hero;
}

export function typeImage(typeKey) {
  const p = allProducts.find((p) => p.types.includes(typeKey) && p.images[0]);
  return p ? p.images[0] : IMAGES.hero;
}

export const fmtPrice = (n) =>
  n > 0
    ? new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(n)
    : "Price on Request";

// ---- Backend API persistence ----
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const saveInquiry = (data) => axios.post(`${API}/inquiries`, data);
export const saveBooking = (data) => axios.post(`${API}/bookings`, data);
export const saveSubscriber = (email) => axios.post(`${API}/subscribers`, { email });
export const saveRateAlert = (data) => axios.post(`${API}/rate-alerts`, data).then((r) => r.data);
export const fetchGoldRates = () => axios.get(`${API}/gold-rates`).then((r) => r.data);

export function waLink(text) {
  return `${STORE.whatsappLink}?text=${encodeURIComponent(text)}`;
}

export function waShareLink(text) {
  return `https://wa.me/?text=${encodeURIComponent(text)}`;
}

export const skuFromHandle = (handle) =>
  handle ? handle.split("-").pop().toUpperCase() : null;

export const productUrl = (handle) => `${window.location.origin}/product/${handle}`;
